module.exports = __webpack_public_path__ + "static/img_face_colours-cdc5a233579367be604a70c5bfffce48.png";